import type { DeepPartial } from '@luna/utils-ts';

import { documentsSKFeatureConfig } from './documents/SK';
import { ordersSKFeatureConfig } from './orders/SK';
import { overviewSKFeatureConfig } from './overview/SK';
import { pipSKFeatureConfig } from './pip/SK';
import { printSKFeatureConfig } from './print/SK';
import { productSettingsSKFeatureConfig } from './productSettings/SK';
import { regularOrdersFeatureConfigSK } from './regularOrders/SK';
import { searchSKFeatureConfig } from './search/SK';
import { statementsSKFeatureConfig } from './statements/SK';
import { tradingConfigSK } from './trading/SK';
import { titleDetailSKConfig } from './titleDetail/SK';
import type { InvestmentsFeatureConfig } from '../types/InvestmentsFeatureConfig';

export const investments: DeepPartial<InvestmentsFeatureConfig> = {
    documents: documentsSKFeatureConfig,
    orders: ordersSKFeatureConfig,
    overview: overviewSKFeatureConfig,
    pip: pipSKFeatureConfig,
    print: printSKFeatureConfig,
    productSettings: productSettingsSKFeatureConfig,
    regularOrders: regularOrdersFeatureConfigSK,
    search: searchSKFeatureConfig,
    statements: statementsSKFeatureConfig,
    titleDetail: titleDetailSKConfig,
    trading: tradingConfigSK,
};
